import { Reveal, PageHero } from "@/components/bits";
import { COMPANY } from "@/lib/data";

const SECTIONS = [
  {
    h: "1. Who we are",
    p: [
      `Ferry Freight LLC ("Ferry Freight", "we", "us") is a licensed freight brokerage based in California, USA. This Privacy Policy explains what information we collect through ferryfreight.us and how we use it.`,
      "You can reach us at any time with privacy questions via the contact details on our Contact page.",
    ],
  },
  {
    h: "2. Information we collect",
    p: [
      "Contact information you give us: your name, company, email address and phone number when you submit a quote request, contact message, carrier application or agent application.",
      "Shipment information you give us: pickup and delivery locations, freight type, equipment, weight, dates and any notes you include, so we can quote and arrange transportation.",
      "Basic technical data: standard web analytics (such as pages visited) collected automatically to keep the site working and improving.",
    ],
  },
  {
    h: "3. How we use your information",
    p: [
      "To prepare and send quotes, arrange and communicate about shipments, process carrier and agent applications, and respond to your messages.",
      "To notify our dispatch desk when you submit a form — quote and application details are forwarded internally to the team members who handle them.",
      "We do not sell your personal information, and we do not use your details for marketing lists you didn't ask to join.",
    ],
  },
  {
    h: "4. Sharing your information",
    p: [
      "We share shipment details with the vetted carriers and partners performing the work on your load — only what's needed to move the freight.",
      "Service providers that operate our email and hosting may process data on our behalf under contract. We never share your contact details with third parties for their own marketing.",
    ],
  },
  {
    h: "5. Data retention",
    p: [
      "Quote requests, contact messages and applications are kept as long as needed for quoting, business records and legal compliance, then deleted. You can ask us to remove your records at any time.",
    ],
  },
  {
    h: "6. Your choices",
    p: [
      "You may request a copy of the information we hold about you, ask us to correct it, or ask us to delete it — email us and we'll take care of it.",
      "Carrier insurance certificates and operating authority documents are retained for compliance with freight brokerage regulations.",
    ],
  },
  {
    h: "7. Security",
    p: [
      "We use industry-standard safeguards (encrypted transport, access controls) to protect the information you submit. No method of transmission over the internet is 100% secure, but we take protecting your data seriously.",
    ],
  },
  {
    h: "8. Changes to this policy",
    p: [
      "If we update this policy, the revised version will be posted on this page with a new effective date.",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <main>
      <PageHero eyebrow="Legal" title="Privacy Policy" testid="privacy-title" lead={`${COMPANY.name} · Effective March 2025`} />

      <section className="py-14 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6" data-testid="privacy-body">
          <div className="card p-6 sm:p-10 lg:p-12">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.h} delay={0.03 * i}>
                <div className={i === 0 ? "" : "mt-10 pt-10 border-t border-slate-100"}>
                  <h2 className="font-display text-xl sm:text-2xl font-bold text-ink">{s.h}</h2>
                  {s.p.map((t, j) => (
                    <p key={j} className="mt-3 text-slate-700 leading-relaxed">{t}</p>
                  ))}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
